import { render } from "./ProductPriceLinesEditMode.vue?vue&type=template&id=df54b186&ts=true"
import script from "./ProductPriceLinesEditMode.vue?vue&type=script&lang=ts"
export * from "./ProductPriceLinesEditMode.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__